/** Per-source health chips — modelled on the Autobuild console's
 * `FreshnessChip` (`pages/autobuild/WorkloadsSections.tsx`), one per HELM
 * source (fresh / stale / unavailable / partial), as on the AHC page (ticket
 * body, plan §8). */
import { HELM_SOURCE_IDS } from '@a7y/platform-health/helm';
import type { HelmSourceHealth, HelmSourceId } from '@a7y/platform-health/helm';
import { HelmSection } from './HelmSection';

const STATE_META: Record<HelmSourceHealth['state'], { label: string; className: string }> = {
  fresh: {
    label: 'Fresh',
    className:
      'border-zinc-200 bg-zinc-50 text-zinc-600 dark:border-zinc-800 dark:bg-zinc-900 dark:text-zinc-400',
  },
  partial: {
    label: 'Partial',
    className:
      'border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-300',
  },
  stale: {
    label: 'Stale',
    className:
      'border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-300',
  },
  unavailable: {
    label: 'Unavailable',
    className:
      'border-red-300 bg-red-50 text-red-800 dark:border-red-800 dark:bg-red-950/40 dark:text-red-300',
  },
};

export function SourceHealth({
  sourceHealth,
}: {
  sourceHealth: Record<HelmSourceId, HelmSourceHealth>;
}) {
  return (
    <HelmSection title="Source health" lineOn="none">
      <div className="flex flex-wrap gap-2">
        {HELM_SOURCE_IDS.map((id) => {
          const health = sourceHealth[id];
          const meta = STATE_META[health.state];
          return (
            <span
              key={id}
              data-testid={`helm-source-health-${id}`}
              className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${meta.className}`}
              title={
                health.lastSuccessAt
                  ? `Last success ${health.lastSuccessAt}`
                  : 'No successful read yet'
              }
            >
              {id}: {meta.label}
            </span>
          );
        })}
      </div>
    </HelmSection>
  );
}
